<template lang="pug">
  sui-menu(pointing)
    sui-container
      router-link(
        is="sui-menu-item",
        :to="{ name: 'home' }",
        exact) Home

      router-link(
        is="sui-menu-item",
        :to="{ name: 'matches' }") Matches

      router-link(
        is="sui-menu-item",
        :to="{ name: 'teams' }") Teams
</template>

<script>
export default {
  name: 'NavBar',
};
</script>
